<template>
    <div class="content-box" :class="[scenicType, 'tem'+scenicMould, {isIphoneXContent: isIphoneX}, 's'+sid ]">
        <!-- <TopNav :sid="sid"/> -->
        <AMap :sid="sid"/>
        <LeftNav :sid="sid"/>
        <img class="ar" src="./../assets/ar.png" @click="gotoAr" v-if="arData.id && arData.ar_link" alt="">
        <img class="ai" src="./../assets/ai.png" @click="gotoAi" v-if="detail.ai_status == 1" alt="">
        <!-- <MyLocation/> -->
        <detailPopup @showQrcode="showRule = true" @getVedio="getVedio" @playVedio="playVedio" @showPaidVoice="showPaidVoiceFun"/>
        <Search :sid="sid" :isH5="isH5" :navHide="detail.nav_is_show != 1" @showQrcode="showRule = true" :lineLables="lineLables"/>
        <div
            v-if="isWeiXin"
            class="bottom-nav"
            :style="{
                'padding-bottom': isIphoneX ? '0.4rem' : '0',
                height: isIphoneX ? '1.5rem' : '1rem',
            }"
        >
            <div
                class="b-nav-item"
                v-for="(item, index) in navs"
                :key="index"
                @click="junmpPage(item)"
            >
                <div class="center" v-if="item.center">
                    <img
                        :src="
                            item.key == 'map' && scenic == 1
                                ? item.icon2
                                : item.icon
                        "
                        alt="img"
                    />
                    <div
                        :class="{
                            active: item.key == 'map',
                            'active-sc': item.key == 'map' && scenic == 1,
                            active1: item.key == 'map' && isNew
                        }"
                    >
                        {{ item.title }}
                    </div>
                </div>
                <template v-else>
                    <img
                        :src="
                            item.key == 'map' && scenic == 1
                                ? item.icon2
                                : item.icon
                        "
                        alt="img"
                    />
                    <div
                        :class="{
                            active: item.key == 'map',
                            'active-sc': item.key == 'map' && scenic == 1,
                            active1: item.key == 'map' && isNew
                        }"
                    >
                        {{ item.title }}
                    </div>
                </template>
            </div>
        </div>

        <Qrcode :showRule="showRule" :qrcode="qrcode" @close="showRule = false"/>

        <VedioList ref="VedioList" :vedio="vedio" :showAllVedio="showAllVedio" @closeShow="showAllVedio = false"/>

        <Notify ref="Notify" :scenicType="scenicType" :isShowNotify="isShowNotify" :notifyList="notifyList" :notifyIx="notifyIx" :currentNotify="currentNotify" 
            @closeNotify="isShowNotify = false" @showOther="handleShowNotify" :isNew="isNew"/>
            
        <PaidVoice :showPaidVoice.sync="showPaidVoice" :data="paidVoiceItem"/>
        
        <SelectScenic />
    </div>
</template>

<script>
import TopNav from './common/top-classify'
import LeftNav from './common/left-nav'
import AMap from './common/amap'
import DetailPopup from './common/detail-popup'
import MyLocation from './common/my-location-btn'
import Search from './common/search'
import Qrcode from './common/qrcode'
import VedioList from './common/vedioList'
import Notify from './common/notify'
import PaidVoice from './common/paid-voice'
import SelectScenic from './common/select-scenic'
import _ from '../config/util'
import Apis from '../config/apis'
import config from '../config/config'
import nav1 from '@/assets/b-nav1.png'
import nav2 from '@/assets/b-nav2.png'
import nav3 from '@/assets/b-nav3.png'
import nav4 from '@/assets/scenic-vip.png'
import nav5 from '@/assets/home.png'
import nav6 from '@/assets/daolan.png'
import nav7 from '@/assets/vip.png'
import nav8 from '@/assets/daolan1.png'
import nav2Sc from '@/assets/b-nav2-sc.png'
import nav2ScLanyuewan from '@/assets/b-nav2-sc-lanyuewan.png'
import studioNav from '@/assets/studio_unselected_icon.png'
import shopNav from '@/assets/shop_icon.png'
export default {
    name: 'Map',
    components: {
        TopNav,
        LeftNav,
        AMap,
        DetailPopup,
        MyLocation,
        Search,
        Qrcode,
        VedioList,
        Notify,
        PaidVoice,
        SelectScenic
    },
    data() {
        return {
            sid: this.$route.query.id,
            navs: [
                {
                    title: '首页',
                    key: 'scenic',
                    icon: nav1,
                    icon: 'https://scenic.tuliyou.com/upload/uediter/image/20241209/1733725253959466.png',
                },
                {
                    icon: 'https://scenic.tuliyou.com/upload/uediter/image/20241214/1734146633562044.png',
                    title: '服务',
                    key: 'copy',
                    route: '/pages/yesanpo/service/index'
                },
                {
                    title: '导览',
                    key: 'map',
                    icon: nav2,
                    icon2: nav2Sc,
                    icon: 'https://scenic.tuliyou.com/upload/uediter/image/20241214/1734146632953895.png',
                    icon2: 'https://scenic.tuliyou.com/upload/uediter/image/20241216/1734314123592293.png',
                    center: true
                },
                {
                    icon: 'https://scenic.tuliyou.com/upload/uediter/image/20241214/1734146633681679.png',
                    title: '商城',
                    key: 'order',
                    route: '/pages/yesanpo/shop/index'
                },
            ],
            scenic: '',
            isIphoneX: false,
            isH5: false, // 是否为h5页面
            showRule: false, // 是否展示跳转景区通的二维码
            qrcode: '', // 二维码
            vedio: [],
            showAllVedio: false,
            notifyList: [], // 公告列表
            isShowNotify: false, // 是否展示公告
            notifyIx: 0, // 展示的公告下标
            lineLables: [], // 路线标签
            mould:0,
            arData: {}, // 获取到的景区ar数据
            scenicMould: '',
            scenicType: '',
            isNew: false,
            showPaidVoice: false,
            paidVoiceItem: null,
        }
    },
    computed:{
        // 当前分类
        isWeiXin(){
            return this.$store.state.isWeiXin
        },
        detail(){
            return this.$store.state.scenicInfo
        },
        isTowns() {
            return !!(this.$route.query.towns - 0)
        },
        currentNotify() {
            return this.notifyList[this.notifyIx]
        },
    },
    mounted(){
        if(window.navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme' && window.tt) window.uni = window.tt
        else if (window.navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme') {
            let timer = setInterval(() => {
                if(window.tt) {
                    window.uni = window.tt
                    clearInterval(timer)
                }
            }, 100)
        }
        else window.uni = wx
   
        // this.scenic = this.$route.query.scenic // 判断是否景区通
        this.scenic = 1 // 判断是否景区通
        this.mould = this.$route.query.mould
        this.isIphoneX = !(this.$route.query.isIphoneX == 'false')
        var type = this.$route.query.type
        this.isH5 = !!this.$route.query.isH5
        this.scenicType = this.$route.query.scenicType || ''
        // this.isNew = this.$route.query.isNew
        this.isNew = this.$store.state.isNew
        if (this.isTowns) this.navs[0].title = '主页'
        // if(type){
        //     this.navs.push({title: this.isTowns ? '会员' : '景区会员',key: 'vip', icon: nav4})
        // }else{
            this.navs.push({ title: '我的', key: 'vip', icon: 'https://scenic.tuliyou.com/upload/uediter/image/20241209/1733725253674556.png' })
        // }
        // 里水小程序定制导航栏
        if (this.scenicType == 'lishui' || this.scenic == 1) {
            // this.navs[0].title = '主页'
            // this.navs[1].title = '导览'
            // this.navs[2].title = '我的'
            
            // this.navs[0].title = this.$t('main.home')
            // this.navs[1].title = this.$t('main.guided_tour')
            // this.navs[2].title = this.$t('main.my')
        }
        // 三宝国际瓷谷定制导航栏
        if (this.scenicType == 'jingde') {
            this.navs.splice(1, 0, {
                title: '工作室',
                key: 'studio',
                icon: studioNav,
            })
        }
        // 揽月湾
        if(this.scenicType == 'lanyuewan') {
            this.navs = this.navs.map(v => {
                if(v.key == 'map') v.icon2 = nav2ScLanyuewan
                return v
            })
        }

        // 从化田园
        if(this.scenicType == 'conghua') {
            this.navs[0].title = '首页'
            this.navs.splice(1, 0, {
                title: '购物车',
                key: 'shop',
                icon: shopNav,
            })
        }

        // 赣州会昌
        if(this.scenicType == 'huichang') {
            this.navs[2].title = this.$t('main.menber')
        }

        // 世外康旅
        if(this.scenicType == 'shiwaikanglv') {
            this.navs = this.navs.map(v => {
                if(v.key == 'map') v.icon2 = 'https://scenic.tuliyou.com/upload/uediter/image/20240509/1715224281131364.png'
                if(v.key == 'scenic') v.icon = 'https://scenic.tuliyou.com/upload/uediter/image/20240509/1715224281292398.png'
                if(v.key == 'vip') v.icon = 'https://scenic.tuliyou.com/upload/uediter/image/20240508/1715149534523154.png'
                return v
            })
        }

        // 新版小程序
        if(this.isNew) {
            // this.navs[0].icon = nav5
            // this.navs[1].icon = nav6
            // this.navs[2].icon = nav7
            // this.navs = this.navs.map(v => {
            //     if(v.key == 'map') v.icon2 = nav8
            //     return v
            // })
        }


        // 获取分享二维码
        this.getQrcode()
        if(this.sid && this.scenic == 1) {
            this.getNotify()
            // this.getAr()
        }

        // 获取路线标签
        this.getLineLables() 
        // this.getScenicMould() 
    },
    methods: {
        junmpPage(item){
            console.log(item)
            if(item.key && item.key != 'map'){
                 // 一机旅游跳转地址
                var url1 = item.key == 'scenic' ? '/packages/scenic/index/index?id=' : item.key == 'vip' ? '/packages/scenic/vip/index?sid=' : '/packages/scenic/coupon/index?id=' 
                // 景区通跳转地址
                let url2 = item.key == 'scenic' ? '/pages/scenic/index/index?id=' : item.key == 'vip' ? '/pages/scenic/vip/index?sid=' : ''
                if(this.mould == 1){
                    url2 = item.key == 'scenic' ? '/pages/scenic/home/index?id=' : item.key == 'vip' ? '/pages/scenic/vip/index?sid=' : ''
                }
                var url = this.scenic == 1 ? url2 : url1
              
                if(item.key === 'studio') url = '/pages/scenic/studio/index?sid='
                else if (item.key === 'shop') url = '/packages/shop/eBusiness/cart/index?sid='
                if(this.isWeiXin){
                    window.uni.miniProgram.redirectTo({
                        url: url+this.sid
                    }) 
                }else{
                    if(item.key == 'scenic'){
                        let url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/index/index?id=${this.sid}` : `${this.$baseurl}packages/scenic/index/index?id=${this.sid}`
                        if(this.mould == 1){
                        url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/home/index?id=${this.sid}` : `${this.$baseurl}packages/scenic/home/index?id=${this.sid}`
                        }
                        window.location.href = url
                    }
                    if(item.key == 'discount'){
                         var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/coupon/index?id=${this.sid}` : `${this.$baseurl}packages/scenic/coupon/index?id=${this.sid}`
                        window.location.href = url
                    }
                    if(item.key == 'vip'){
                         var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/vip/index?sid=${this.sid}` : `${this.$baseurl}packages/scenic/vip/index?sid=${this.sid}`
                        window.location.href = url
                    }
                }
            }
        },
        getQrcode() {
            // this.axios.post(Apis.posterShare, {
            //     type: 9,
            //     pid: this.sid,
            //     uid: this.uid || 0
            // }).then(res => {
            //     if(res.code == 200) this.qrcode = res.data.qrcode
            // })
        },
        getVedio(vedio){
            this.vedio = vedio
        },
        playVedio(){
            if(this.vedio.length == 1) {
                this.$refs.VedioList.curVedio = this.vedio[0].video_link
                this.$refs.VedioList.showVedio = true
            } else {
                this.showAllVedio = true
            }
        },
        // 获取景区公告
        getNotify(){
            return
            this.axios.post(Apis.scenicNotice, {
                sid: this.sid
            }).then(res => {
                res.data = res.data.map(el => {
                    if (el.content) {
                        el.content = _.formatImg(el.content)
                        .replace(/\<img/gi, '<img style="width:calc(100% - 20px);max-width:calc(100% - 20px);height:auto;border-radius:10px;margin:10px" ')
                        .replace(/<section/g, '<div')
                        .replace(/\/section>/g, '/div>')
                    }
                    return el
                })
                this.notifyList = res.data
                // 增加每天一次自动弹出公告的逻辑
                let date = new Date(),
                // 当前日期字符串拼接
                time = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`,
                // 储存的公告弹窗自动弹出最后日期 [{sid:1, time:2022-8-10}]
                storages = JSON.parse(localStorage.getItem('scenicAutoShowNotices')) || [],
                // 储存的数据中属于当前景区的数据
                data = storages && storages.length ? storages.find(v => v.sid == this.sid) : ''
                if(res.data.length && (!storages || !data || data.time != time)) {
                    let newestIdx = res.data.findIndex(v => v.eject.value == 2)
                    // 弹出公告
                    if(newestIdx != -1) {
                        this.handleShowNotify(newestIdx)
                        // 弹出公告日期数据储存
                        if(!storages) storages = []
                        if (!data) storages.push({sid: this.sid, time})
                        else data.time = time
                        localStorage.setItem('scenicAutoShowNotices', JSON.stringify(storages))
                    }
                }
            })
        },
        // 公告展示
        handleShowNotify(ix) {
            this.notifyIx = ix
            this.isShowNotify = true
        },
        // 获取路线标签
        getLineLables() {
            this.lineLables = [{
                id: '',
                title: '全部'
            }]
            return
            this.axios.post(Apis.scenicLineLabels, {
                sid: this.sid
            }).then(res => {
                this.lineLables = res.data
            })
        },
        getAr(){
            this.axios.post(Apis.scenicMapAr, {
                sid: this.sid
            }).then(res => {
                if(res.data && res.data.id) this.arData = res.data
            })
        },
        gotoAi() {
            let url = `/packages/etc/ai/index?sid=${this.sid}`
            if(this.isWeiXin){
                window.uni.miniProgram.navigateTo({
                    url: url
                }) 
            }else {
                url = (this.scenic == 1 ? this.$scenicUrl : this.$baseurl) + url
                window.location.href = url
            }
        },
        gotoAr(){
            let url = `/packages/etc/arscript/index?id=${this.arData.id}&type=scenicMapAr`
            if(this.isWeiXin){
                window.uni.miniProgram.navigateTo({
                    url: url
                }) 
            }else {
                url = (this.scenic == 1 ? this.$scenicUrl : this.$baseurl) + url
                window.location.href = url
            }
        },
        getScenicMould() {
            this.axios.post(Apis.scenicMould, {
                sid: this.sid
            }).then(res => {
                this.scenicMould = res.data.mould_type
                // 模板13使用别的图标
                if(res.data.mould_type == 13) {
                    this.navs = this.navs.map(v => {
                        if(v.key == 'scenic') v.icon = require('@/assets/mould13/tab_home_U.png')
                        else if(v.key == 'map') v.icon2 = require('@/assets/mould13/tab_Guide_S.png')
                        if(v.key == 'vip') v.icon = require('@/assets/mould13/tan_me_U.png')
                        return v
                    })
                }
            })
        },
        showPaidVoiceFun(item) {
            this.showPaidVoice = true
            this.paidVoiceItem = item
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
#amap {
    height: calc(100vh - 1rem);
    width: 100%;
}
.ar {
    width: 80px;
    height: 70px;
    position: fixed;
    bottom: 191px;
    left: 27px;
    z-index: 2;
}
.ai {
    width: 1.46rem;
    height: 1.8rem;
    position: fixed;
    bottom: 2.24rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}
.isIphoneXContent .ai {
    bottom: 2.6rem;
}
</style>
